import { api } from "./api";

export const appService = {
    menu: <T>() => api.get<{ data: T }>("/app/menu"),
    permissions: (mode: string, clsnam: string, keyval?: number) =>
        api.get<{ message: string }>("/app/permissions", { params: { mode, clsnam, keyval } }),
};
